import {convertNumberToRoman} from 'cr-numeral';

import {MarkupNodeType, MarkupUnorderedListType} from '#src/constants.js';

const BULLET_MAP = new Map([
  [MarkupUnorderedListType.Disc, '•'],
  [MarkupUnorderedListType.Circle, '◦'],
  [MarkupUnorderedListType.Square, '▪']
]);

const BULLET_SYMBOLS_LOWERCASE = 'abcdefghijklmnopqrstuvwxyz';
const BULLET_SYMBOLS_UPPERCASE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

function _generateSymbolBullet(symbols, index) {
  let s = symbols[index % symbols.length];

  index = Math.floor(index / symbols.length) - 1;

  while (index >= 0) {
    s = symbols[index % symbols.length] + s;

    index = Math.floor(index / symbols.length) - 1;
  }

  return s;
}

export function getListBullet(type, data, index) {
  if (type === MarkupNodeType.UnorderedList) {
    return BULLET_MAP.get(data?.type) || '•';
  }

  switch (data?.type) {
  case 'A':
    return `${_generateSymbolBullet(BULLET_SYMBOLS_UPPERCASE, index - 1)}.`;
  case 'a':
    return `${_generateSymbolBullet(BULLET_SYMBOLS_LOWERCASE, index - 1)}.`;
  case 'i':
    return `${convertNumberToRoman(index).toLowerCase()}.`;
  case 'I':
    return `${convertNumberToRoman(index)}.`;
  default:
    return `${index}.`;
  }
}
